<template>
  <div class="home-section">
    <ProviderSlider :logos="logos" />
    <ExpandableText
      title="Casino 2025 — Best Real-Money Casino Games & €/\$900 Bonus"
      :fullText="description"
    />
    <FooterNav />
  </div>
</template>

<script>
import ProviderSlider from "./ProviderSlider.vue";
import ExpandableText from "./ExpandableText.vue";
import FooterNav from "./FooterNav.vue";

export default {
  name: "Footer",
  components: {
    ProviderSlider,
    ExpandableText,
    FooterNav,
  },
  data() {
    return {
      logos: [
        "/img/logos/aceroll.svg",
        "/img/logos/apparat.svg",
        "/img/logos/backseatgaming.svg",
        "/img/logos/bgaming.svg",
        "/img/logos/endorphina.svg",
        "/img/logos/evoplay.svg",
        "/img/logos/booming.svg",
        "/img/logos/bullsharkgames.svg",
        "/img/logos/clawbuster.svg",
        "/img/logos/hacksaw.svg",
        "/img/logos/inout.svg",
        "/img/logos/kitsunegaming.svg",
        "/img/logos/mascot.svg",
        "/img/logos/netent.svg",
        "/img/logos/nownow.svg",
        "/img/logos/popiplay.svg",
        "/img/logos/slotopia.svg",
        "/img/logos/spnmnl.svg",
        "/img/logos/trustygaming.svg",
      ],
      description: `Casino is a vibrant online venue for all players. It features a massive library of over 9,600 games — from online slots with themed elements to classic table games that require serious strategy. casino also offers a live dealer section where real professionals deal your cards. New players are welcomed with a generous bonus to start their gaming adventure and enjoy regular promotions along the way. Free spins are also available, so you can enjoy rewards right from the start.`,
    };
  },
};
</script>

<style scoped>
.home-section {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}

@media only screen and (max-width: 640px) {
  .home-section {
    padding: 8px;
  }
}
</style>
